import { useCallback } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

// Locals
import withHooks from './withHooks';

const defaultAcls = ['GROUP:ADMIN'];

const makeMapStateToProps = () => {
  let lastKey = '';
  let lastScopes;

  return ({ acls }) => {
    const scopes = acls?.scopes || [];
    const key = Array.isArray(scopes) ? scopes.join('|') : '';
    // If contents are the same (by key), reuse the last array reference
    if (key === lastKey) {
      return { scopes: lastScopes };
    }

    lastKey = key;
    lastScopes = scopes;
    return { scopes };
  };
};

const enhancer = compose(
  connect(makeMapStateToProps(), null),
  withHooks(props => {
    const containScopes = useCallback(
      name => {
        const roles = [].concat(name, defaultAcls);
        const isAuthorized = props?.scopes?.some(scope =>
          roles.includes(scope)
        );
        return !isAuthorized;
      },
      [props.scopes]
    );

    return {
      ...props,
      containScopes
    };
  }, [])
);

export default enhancer;
